<template>
    <b-card class="inner-block review-types">
        <b-card-header>
            <b-row class="mt-2">
                <b-col cols="12" class="d-flex">
                    <b-input v-model="filter" type="text" :placeholder="$translate('search_review_type')"></b-input>
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>

        <b-card-body>
            <b-col class="page-block"><strong>{{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }}
                    {{ Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                    {{ rows }}</strong></b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage" :current-page="currentPage"
                    :filter="filter">
                    <template #cell(id)="row">
                        <b-button :id="'view-checkoff-type-btn-'+row.item.id" v-if="hasPermissionView" variant="pink-button" @click="$emit('show-item', row.item.id)"
                            class="mr-2 test-view-checkoff-type-btn">
                            <img src="@/assets/images/icon/view.svg" alt="view" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-card-body>
        <b-row>
            <b-col>
                <b-pagination class="float-right" v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage"
                    :next-text="$translate('Next')" :prev-text="$translate('previous')" aria-controls="roleTable" pills
                    align="center"></b-pagination>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reviewTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() { },

    methods: {},

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
                {
                    key: 'enforced',
                    label: this.$translate('mandatory'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
                {
                    key: 'do_release',
                    label: this.$translate('do_release'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
                {
                    key: 'attachment_require',
                    label: this.$translate('attachment_require'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
                {
                    key: 'ext_acc_bill_generate',
                    label: this.$translate('ext_acc_bill_generate'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
                {
                    key: 'signature_require',
                    label: this.$translate('signature_require'),
                    formatter: value => (parseInt(value) ? this.$translate('yes') : this.$translate('no')),
                },
                { key: 'description', label: this.$translate('description') },
            ]
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        },
    },
}
</script>
<style></style>
